// extracted by mini-css-extract-plugin
export default {"modal":"ModalTemplateBasic_modal__TfMM3","container":"ModalTemplateBasic_container__3i5ri"};